'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AbstractElement from '../elements/AbstractElement';
const HORIZONTAL_ALIGNMENT_TYPES = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right'
};
const VERTICAL_ALIGNMENT_TYPES = {
  top: 'private-multicolumn--align-top',
  middle: 'private-multicolumn--align-middle',
  bottom: 'private-multicolumn--align-bottom'
};

const getTitleText = titleText => {
  return /*#__PURE__*/_jsx(AbstractElement, {
    className: "private-multicolumn__item__title",
    children: titleText
  });
};

export default function UIMultiColumnItem(props) {
  const {
    children,
    className,
    horizontalAlign,
    titleText,
    verticalAlign,
    width
  } = props,
        other = _objectWithoutPropertiesLoose(props, ["children", "className", "horizontalAlign", "titleText", "verticalAlign", "width"]);

  const renderedTitle = titleText ? getTitleText(titleText) : null;
  return /*#__PURE__*/_jsxs("div", Object.assign({}, other, {
    className: classNames("private-multicolumn__item has--vertical-spacing", HORIZONTAL_ALIGNMENT_TYPES[horizontalAlign], VERTICAL_ALIGNMENT_TYPES[verticalAlign], className),
    style: {
      width
    },
    children: [renderedTitle, children]
  }));
}
UIMultiColumnItem.displayName = 'UIMultiColumnItem';
UIMultiColumnItem.propTypes = {
  children: PropTypes.node,
  horizontalAlign: PropTypes.oneOf(Object.keys(HORIZONTAL_ALIGNMENT_TYPES)),
  titleText: PropTypes.node,
  verticalAlign: PropTypes.oneOf(Object.keys(VERTICAL_ALIGNMENT_TYPES)),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
UIMultiColumnItem.defaultProps = {
  verticalAlign: 'middle'
};